import React from "react";
const SvgBellFilledOff = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#000">
      <path d="M4.631 3.924l-.777-.778a.5.5 0 10-.708.708L6.37 7.077c-.38.71-.58 1.49-.58 2.295v.15c0 2.511-.55 4.971-1.64 7.31a1.51 1.51 0 00.11 1.482c.29.434.78.696 1.31.696h12.733l1.843 1.844a.5.5 0 00.786-.607l-.16-.157-1.248-1.228c-1.06-1.044-2.537-2.503-4.21-4.163-3.344-3.32-7.473-7.45-10.602-10.677a.755.755 0 01-.08-.098zM19.98 17.205c-.988-.974-2.232-2.204-3.608-3.57A1041.864 1041.864 0 017.99 5.23a6.461 6.461 0 011.502-.83c.5-.847 1.45-1.391 2.51-1.391 1.061 0 2.022.544 2.522 1.411 2.221.888 3.692 2.924 3.692 5.102 0 2.51.55 4.97 1.64 7.31.058.12.099.245.123.372z" />
      <path d="M9.37 19.88c.43.95 1.45 1.62 2.63 1.62s2.2-.67 2.63-1.62H9.37z" />
    </g>
  </svg>
);
export default SvgBellFilledOff;
